/**
 * 传感器方案-超声波硬件方案
 */
import React, { useState } from 'react';
import { Card, Form, Row, Col, Input, Button } from 'antd';
import { sensorUltrasonicHardwareListRequest } from '@/service/sensorUltrasonicHardware';
import { sensorSchemeCommonColumns } from '@/columns/sensorScheme';
import { useTable } from '@/utils/useTable';
import { operateTimeRange } from '@/utils/operateSearchParams';
import CommonTable from '@/components/commonTable';
import RenderEllipsisColumn from '@/components/renderEllipsisColumn';
import PermissionButton from '@/components/permissionButton';
import SensorCommonSearch from '@/components/sensorCommonSearch';
import { formSearchGutter } from '@/constants/common';
import OperateModal from './components/operateModal';
import styles from '@/styles/pageContent.module.scss';

const SensorUltrasonicHardware = () => {
  const [form] = Form.useForm();
  const [operateInfo, setOperateInfo] = useState<any>({}); // 操作相关的信息
  const [searchParams, setSearchParams] = useState({}); // 搜索相关的参数
  const { page, limit, loading, data, totalCount, onPageChange, getData } =
    useTable({
      requestFunc: sensorUltrasonicHardwareListRequest,
      searchParams
    });

  // 搜索
  const onSearch = async (values: any) => {
    const newSearchParams = operateTimeRange(values, true);
    setSearchParams(newSearchParams);
  };

  // 表格列显示
  const columns = [
    {
      title: '方案ID',
      dataIndex: 'id',
      width: 70,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '方案名称',
      dataIndex: 'name',
      width: 110,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '方案描述',
      dataIndex: 'description',
      width: 120,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '设备名称',
      dataIndex: 'componentName',
      width: 110,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '供应商',
      dataIndex: 'supplierName',
      width: 110,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '型号',
      dataIndex: 'model',
      width: 110,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '版本号',
      dataIndex: 'version',
      width: 110,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    ...sensorSchemeCommonColumns,
    {
      title: '操作',
      dataIndex: 'operate',
      width: 120,
      fixed: 'right' as const,
      render: (value: any, item: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <PermissionButton
              operateType="/car-admin/sensorUltrasonic-hardware/edit"
              type="link"
              onClick={() => setOperateInfo({ type: 'edit', data: item })}
            >
              编辑
            </PermissionButton>
            <PermissionButton
              operateType="/car-admin/sensorUltrasonic-hardware/viewDetail"
              type="link"
              onClick={() => setOperateInfo({ type: 'detail', data: item })}
            >
              查看
            </PermissionButton>
          </div>
        );
      }
    }
  ];

  return (
    <Card bordered={false} className={styles.fixPageContentBox}>
      <Form onFinish={onSearch} form={form} autoComplete="off">
        <Row gutter={formSearchGutter}>
          <Col span={5}>
            <Form.Item label="方案名称" name="name">
              <Input placeholder="请输入方案名称" allowClear />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="厂商" name="supplierName">
              <Input placeholder="请输入厂商名称" allowClear />
            </Form.Item>
          </Col>
          <SensorCommonSearch span={6} />
          <Col span={2}>
            <Form.Item>
              <div className={styles.searchBox}>
                <Button type="primary" htmlType="submit">
                  搜索
                </Button>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className={styles.operateBox}>
        <PermissionButton
          operateType="/car-admin/sensorUltrasonic-hardware/add"
          type="primary"
          onClick={() => setOperateInfo({ type: 'add' })}
        >
          新增超声波硬件方案
        </PermissionButton>
      </div>
      <CommonTable
        rowKey="id"
        columns={columns}
        dataSource={data}
        pagination={{
          total: totalCount,
          current: page,
          pageSize: limit,
          onChange: onPageChange
        }}
        bordered
        loading={loading}
      />
      {['add', 'edit', 'detail'].includes(operateInfo.type) && (
        <OperateModal
          type={operateInfo.type}
          data={operateInfo.data}
          closeModal={() => setOperateInfo({})}
          reloadData={getData}
        />
      )}
    </Card>
  );
};

export default SensorUltrasonicHardware;
